import { NodeModel } from "@minoru/react-dnd-treeview";
import { GQLContentForm } from "@quales/data-access/graphql";
import { GetFormSchemaItem, GetUIFormSchemaItem } from "./GetFormSchemaItem";
import { GetUISchemaPath } from "./GetUISchemaPath";
import lodash from "lodash";
import { nanoid } from "nanoid";
import { SetUiOrderForNewItem } from "./SetUiOrderForNewItem";
import { getDuplicateUiSchemaValues } from "./GetDuplicateUiSchemaValues";
import { GetFormSchemaPath } from "./GetFormSchemaPath";

export const GetDuplicateItem = (
  node: NodeModel,
  formContent: GQLContentForm
) => {
  const formItem = GetFormSchemaItem(node.id.toString(), formContent);
  const findParentItem = GetFormSchemaItem(node.parent.toString(), formContent);
  const findUIItem = GetUIFormSchemaItem(node.id.toString(), formContent);
  //@ts-ignore
  const getSchemaPath = GetFormSchemaPath(node.parent, formContent);
  const getUISchemaPath = GetUISchemaPath(getSchemaPath);
  const currentFormContent = lodash.cloneDeep(formContent.formSchema);
  const itemType = node.id.toString().split("_")[0];
  const itemID = nanoid(6);

  if (node.parent === "root") {
    if (itemType !== "object") {
      const getUiOptions = SetUiOrderForNewItem(
        getUISchemaPath,
        //@ts-ignore
        `${itemType}_${itemID}`,
        formContent
      );

      if (findUIItem) {
        getUiOptions[`${itemType}_${itemID}`] = findUIItem;
      }

      //@ts-ignore
      currentFormContent.properties[`${itemType}_${itemID}`] = formItem;

      return {
        formSchema: { ...currentFormContent },
        uiSchema: { ...getUiOptions },
      };
    } else {
      //@ts-ignore
      currentFormContent.properties[`${itemType}_${itemID}`] = {
        ...formItem,
        title: formItem.title + "-copy",
      };
      const isEmpty =
        Object.keys(
          currentFormContent.properties[`${itemType}_${itemID}`].properties
        ).length === 0 &&
        currentFormContent.properties[`${itemType}_${itemID}`].properties
          .constructor === Object;
      const getUiOptions = SetUiOrderForNewItem(
        getUISchemaPath,
        //@ts-ignore
        `${itemType}_${itemID}`,
        formContent
      );
      getUiOptions[`${itemType}_${itemID}`] = findUIItem;

      if (isEmpty) {
        return {
          formSchema: { ...currentFormContent },
          uiSchema: { ...getUiOptions },
        };
      } else {
        const newObjectValues =
          currentFormContent.properties[`${itemType}_${itemID}`];
        let newKeys = {};
        const oldNewPeyPair = [];
        Object.entries(newObjectValues.properties).forEach(([key, value]) => {
          const newItemID = nanoid(6);
          const newItemType = key.toString().split("_")[0];
          oldNewPeyPair.push({
            oldKey: key,
            newKey: `${newItemType}_${newItemID}`,
          });
          newKeys = {
            ...newKeys,
            [`${newItemType}_${newItemID}`]: value,
          };
        });

        currentFormContent.properties[`${itemType}_${itemID}`].properties = {
          ...newKeys,
        };

        getUiOptions[`${itemType}_${itemID}`] = { "ui:order": [] };
        Object.entries(newObjectValues.properties).forEach(([key, value]) => {
          getUiOptions[`${itemType}_${itemID}`]["ui:order"].push(key);
        });
        const newDuplicateUiSchema = getDuplicateUiSchemaValues(
          oldNewPeyPair,
          getUiOptions,
          findUIItem,
          `${itemType}_${itemID}`
        );

        return {
          formSchema: { ...currentFormContent },
          uiSchema: { ...newDuplicateUiSchema },
        };
      }
    }
  } else {
    findParentItem.properties = {
      ...findParentItem.properties,
      [`${itemType}_${itemID}`]: { ...formItem },
    };
    const getUiOptions = SetUiOrderForNewItem(
      getUISchemaPath,
      `${itemType}_${itemID}`,
      formContent
    );

    if (findUIItem) {
      lodash.set(getUiOptions, getUISchemaPath, {
        ...getUiOptions[getUISchemaPath],
        [`${itemType}_${itemID}`]: findUIItem,
      });
    }

    lodash.set(currentFormContent, getSchemaPath, {
      ...findParentItem,
    });

    return {
      formSchema: currentFormContent,
      uiSchema: { ...getUiOptions },
    };
  }
};
